import { price_override_cache_server } from "./price_override_cache_server";
import { price_override_product } from "./price_override_product";
export class  price_override{

    public id:string;
    public name:string;
    public percentage:number;
    public cache_servers:price_override_cache_server[]=[];
    public products:price_override_product[]=[];
}